@let apartment = apartment$ | async;
@if (apartment) {
  <article homeyApartmentDetailPageContent
    [apartment]="apartment"
    [householdSize]="1"
    [showH2]="true"
    [relevantApartmentsInput]="{ type: 'all' }"
  >
    <homey-apartment-detail-info-item
      apartmentUnits
      icon="pi-warehouse"
      title="Units"
    >
      @if (apartment.type === "regular") {
        <homey-regular-eligible-units [eligibleUnits]="apartment.unitTypes" />
      }
      @else {
        <homey-senior-eligible-units [eligibleUnits]="apartment.unitTypes" />
      }
    </homey-apartment-detail-info-item>
    <ng-container otherBlocks>
      <div>
        <p class="font-medium text-xl mt-2 mb-6 text-center">
          Want to know if you're eligible?
        </p>
        <div class="flex flex-row justify-center">
          <a pButton [routerLink]="initialSignupRoute" size="small" severity="info" label="Check eligibility"></a>
        </div>
        <p-divider/>
      </div>
    </ng-container>
  </article>

  <homey-lotteries-and-footer [defaultSignupRoute]="initialSignupRoute">
    <ng-container footerTitle>
      Apply in minutes<br />
      <span class="text-orange-gradient">
        We’ll handle the rest.
      </span>
    </ng-container>
  </homey-lotteries-and-footer>
}
